import React from 'react';
import { Modal, Input, Form, Select, Row, Col, Divider, Icon, Popover, Button } from 'antd';
import { FORMAT_2DECIMALS, GREATER_THAN_ZERO } from '../../../common/types/regularExpresionType';
import global from '../../../common/utility/global';
import dialog from "../../../common/utility/dialog";

const { Option } = Select;

class FormModal extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
        }
    }

    handleCancel = () => {
        this.props.onClose();
        this.props.form.resetFields();
    }

    handleAdd = () => {
        this.props.form.setFieldsValue({ isCredito: true });

        //this.props.onAddCredito()
    }

    handleOk = (e) => {
        e.preventDefault();
        this.props.form.validateFieldsAndScroll((err, values) => {
            console.log(values);
            if (!err) {
                const form = {
                    id: values.id,
                    nombre: values.nombre,
                    valor: parseFloat(values.valor),
                    idCredito: values.idCredito === undefined ? 0 : values.idCredito.key,
                    codigo: values.codigo,
                    credito: values.credito == undefined ? null : values.credito,
                }

                if (form.credito !== null && form.credito !== undefined) {
                    const creditoIngresado = form.credito.trim();

                    const existeCredito = this.props.formValues.tipoCreditos.some(e => e.nombre === creditoIngresado);

                    if (existeCredito) {
                        dialog.warning("Tipo de crédito ya existe.");
                        return false;
                    }
                }
                if (form.valor > 100) {
                    dialog.warning("Ingrese un valor valido de tasa %");
                    return false;
                }

                this.props.onSave(form, this.props.form);
            }
        });
    }


    render() {
        const { getFieldDecorator, getFieldValue } = this.props.form;

        getFieldDecorator('id', { initialValue: this.props.formValues.id });
        getFieldDecorator('codigo', { initialValue: this.props.formValues.codigo });
        getFieldDecorator('isCredito', { initialValue: false });

        return (
            <Modal
                title={this.props.formValues.id === 0 ? "Registrar Tipo de Crédito" : "Modificar Tipo de Crédito"}
                visible={this.props.visible}
                cancelText={"Cancelar"}
                okText={"Guardar"}
                onCancel={this.handleCancel}
                onOk={this.handleOk}
                style={{ top: 30 }}
            >
                <Form>
                    <Row gutter={16}>
                        <Col className="gutter-row" span={24}>
                            <Form.Item label="Nombre">
                                {getFieldDecorator('nombre', {
                                    initialValue: this.props.formValues.nombre,
                                    rules: [{
                                        required: true,
                                        message: 'Campo obligatorio.',
                                        whitespace: true
                                    }]
                                })(
                                    <Input
                                        placeholder="Ingresar nombre"
                                        autoComplete="off"
                                    />
                                )}
                            </Form.Item>
                        </Col>
                    </Row>

                    <Row gutter={16}>
                        <Col className="gutter-row" span={24}>
                            <Form.Item label="Tasa %">
                                {getFieldDecorator('valor', {
                                    initialValue: parseFloat(this.props.formValues.valor).toFixed(2),
                                    rules: [{
                                        pattern: new RegExp(FORMAT_2DECIMALS),
                                        message: "Formato decimal incorrecto (0.00)"
                                    },
                                    {
                                        required: true,
                                        pattern: new RegExp(GREATER_THAN_ZERO),
                                        message: "Ingrese un valor mayor a 0.00"
                                    }
                                    ]
                                })(
                                    <Input
                                        addonAfter={<Icon type="percentage" />}
                                        className="text-right"
                                        placeholder="Ingresar tasa"
                                        autoComplete="off"
                                        maxLength={100}
                                        onKeyPress={global.onKeyPressDecimals}
                                        onBlur={(e) => {
                                            this.props.form.setFieldsValue({
                                                stockMin: global.onBlurDecimals(e, 2)
                                            });
                                        }}
                                    />
                                )}
                            </Form.Item>
                        </Col>
                    </Row>
                    {this.props.form.getFieldValue("isCredito") ?

                        null : <Row gutter={16}>
                            <Col className="gutter-row" span={24}>
                                <Form.Item label="Tipo Crédito">
                                    {getFieldDecorator('idCredito', {
                                        initialValue: this.props.formValues.idCredito > 0 ?
                                            { key: this.props.formValues.idCredito } : undefined,
                                        rules: [{
                                            required: true,
                                            message: 'Campo obligatorio.',
                                        }]
                                    })(
                                        <Select showSearch labelInValue
                                            placeholder={"Seleccione Tipo Credito"}
                                            optionFilterProp="children"
                                            dropdownRender={menu => (
                                                <div>
                                                    {menu}
                                                    <Divider style={{ margin: '4px 0' }} />
                                                    <div
                                                        style={{ padding: '4px 8px', cursor: 'pointer' }}
                                                        onMouseDown={e => e.preventDefault()}
                                                        onClick={this.handleAdd}
                                                    >
                                                        <Icon type="plus" /> Añadir Nuevo

                                                    </div>
                                                </div>
                                            )}
                                        >
                                            {this.props.formValues.tipoCreditos.map(item => (
                                                <Option key={item.id} value={item.id} >{item.nombre} </Option>
                                            ))}
                                        </Select>
                                    )}
                                </Form.Item>
                            </Col>
                        </Row>
                    }

                    {this.props.form.getFieldValue("isCredito") ?
                        <Row gutter={16}>
                            <Col className="gutter-row" span={24}>
                                <Form.Item label="Tipo Credito">
                                    {getFieldDecorator('credito', {
                                        initialValue: this.props.formValues.credito,
                                        rules: [{
                                            required: true,
                                            message: 'Campo obligatorio.',
                                            whitespace: true
                                        }]
                                    })(
                                        <Input
                                            placeholder="Ingresar credito"
                                            autoComplete="off"
                                        />
                                    )}
                                </Form.Item>
                            </Col>
                        </Row>
                        : null}


                </Form>
            </Modal>
        );
    }
}
export default Form.create()(FormModal)